import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=79681176&scoped=true"
import script from "./prompt.vue?vue&type=script&lang=js"
export * from "./prompt.vue?vue&type=script&lang=js"
import style0 from "./prompt.vue?vue&type=style&index=0&id=79681176&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79681176",
  null
  
)

export default component.exports